import { useDispatch, useSelector } from 'react-redux';
import { useGetLoadedParams } from '../../../hooks/paramsHooks';
import {
  default as accessSettingsActions,
  selectors as accessSettingsSelectors,
} from '../../../modules/accessSettings';
import { default as apartmentActions, selectors as apartmentSelectors } from '../../../modules/apartments';
import { ApplicationContext } from '../../../modules/commonTypes';
import { actionsTS } from '../../../modules/user';
import { TUserActionContext } from '../../../modules/user/actionsTS';

interface IUserDataGridData {
  filter: { fulltext: string };
  order: string;
  page: number;
  rowsPerPage: number;
}

export function useRefreshData(context: TUserActionContext, userDataGridData?: IUserDataGridData) {
  const { companyId, siteId } = useGetLoadedParams(ApplicationContext.Site);
  const dispatch = useDispatch();
  const accessGroupId = useSelector(accessSettingsSelectors.getAccessGroupId);
  const accessGroupUsersGridData = useSelector((state: any) => state.accessSettings.groupDetail.users);
  const apartmentId = useSelector(apartmentSelectors.getApartmentId);
  const apartmentUsersGridData = useSelector((state: any) => state.apartments.apartmentUsers.list);

  function refreshData() {
    switch (context) {
      case 'SITE_USERS_LIST':
        dispatch(
          actionsTS.getSiteUsersList(
            companyId,
            siteId,
            userDataGridData?.page || 0,
            userDataGridData?.rowsPerPage || 10,
            userDataGridData?.filter || { fulltext: '' },
            userDataGridData?.order || 'asc'
          )
        );
        break;
      case 'SITE_USER_DETAIL':
        break;
      case 'ACCESS_SETTINGS_USERS_LIST':
        dispatch(
          accessSettingsActions.getAccessGroupUsers(
            companyId,
            siteId,
            accessGroupId,
            accessGroupUsersGridData?.page || 1,
            accessGroupUsersGridData?.rowsPerPage || 10,
            accessGroupUsersGridData?.filter || { fulltext: '' },
            accessGroupUsersGridData?.order || 'lastName'
          )
        );
        break;
      case 'APARTMENT_USERS_LIST':
        dispatch(
          apartmentActions.getApartmentUsers(
            apartmentId,
            companyId,
            siteId,
            apartmentUsersGridData?.page || 1,
            apartmentUsersGridData?.rowsPerPage || 10,
            apartmentUsersGridData?.filter || { fulltext: '' },
            apartmentUsersGridData?.order || '-role'
          )
        );
        break;
      default:
        break;
    }
  }

  return { refreshData };
}
